import restService, { RestError } from "../rest-service/RestService";

const OfflineDetectionService = {

    isOnline: async function(): Promise<boolean> {

        try {
            await restService.post("ping", null);

            return true;

        } catch(error) {

            const restError = error as RestError;

            if (restError && restError.offline) {
                return false;
            }

            throw(error);
        }
    }
};

export default OfflineDetectionService;